module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[86]207.a7c7f2f.woff2";